import Layout from "../containers/Layout";
import ExternalLogin from "../containers/ExternalLogin";

var indexRoutes = [
  { path: "/extlogin", name: "External Login", component: ExternalLogin, public: true },
  { path: "/", name: "Home", component: Layout },
];

export default indexRoutes;
